import React, { useState } from "react"
import Autocomplete from "@mui/material/Autocomplete"
import TextField from "@mui/material/TextField"
import Checkbox from "@mui/material/Checkbox"
import { Chip } from "@mui/material"

const MultiSelectWithCheckbox = (props) => {
  const { options, label = "", size = "small", containerStyle } = props
  const [selectedOptions, setSelectedOptions] = useState([])

  const handleChange = (event, value) => {
    setSelectedOptions(value)
    if (props?.onSelectOptions) {
      props.onSelectOptions(value)
    }
  }


  return (
    <div style={{ marginBottom: "20px", ...containerStyle }}>
      <Autocomplete
        multiple
        // limitTags={1}
        id="checkboxes-tags-demo"
        options={options}
        label="Clinics"
        disableCloseOnSelect
        getOptionLabel={(option) => option.label}
        value={selectedOptions}
        onChange={handleChange}
        renderOption={(props, option, { selected }) => {
          return (
            <li {...props}>
              <Checkbox
                checked={selected}
                style={{ marginRight: 8 }}
              />
              {option.label}
            </li>
          )
        }}
        renderInput={(params) => (
          <TextField {...params} label={label} variant="outlined" size={size} />
        )}
        isOptionEqualToValue={(option, value) => option._id === value._id} // To compare by _id
      />
    </div>
  )
}

export default MultiSelectWithCheckbox
